import React from "react";
import HeroKPIs from "../HeroKPIs";
import { TAB_TITLES, TAB_SUBTITLES } from "../../constants/tabs";

/**
 * Full-bleed hero on Squad Overview; compact page-title strip on
 * every other tab. Extracted so the Dashboard shell doesn't own the
 * ~50 lines of hero markup + branding backdrop.
 */
export default function HeroBanner({ tab, overview, injurySummary }) {
  if (tab === "overview") {
    return (
      <div className="relative overflow-hidden" data-testid="hero-banner">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-[0.18]"
          style={{
            backgroundImage:
              "url('https://images.pexels.com/photos/9716320/pexels-photo-9716320.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#040D1A]/40 via-[#040D1A]/60 to-[#040D1A]" />
        <div className="relative px-4 md:px-8 pt-6 md:pt-8 pb-4 max-w-[1600px] mx-auto">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div className="max-w-2xl">
              <div className="text-xs uppercase tracking-[0.25em] text-cyan-300/80 mb-2">
                Coach intelligence · 2018 → 2026
              </div>
              <h1 className="font-display font-extrabold text-3xl md:text-5xl leading-[1.05]">
                Read your squad <span className="text-cyan-300">like a map.</span>
              </h1>
            </div>
            <p className="text-slate-300/90 text-sm md:text-right leading-relaxed max-w-md md:ml-auto md:pt-1">
              Longitudinal blood-work for every athlete — iron, vitamins, thyroid, kidney, liver and
              inflammation markers — visualised against lab reference ranges.
            </p>
          </div>

          <div className="mt-5">
            <HeroKPIs overview={overview} injurySummary={injurySummary} />
          </div>
        </div>
      </div>
    );
  }
  // Compact page-title strip on non-overview tabs. Uses the same
  // horizontal padding as the main body so it lines up.
  return (
    <div className="px-4 md:px-8 pt-4 pb-2 max-w-[1600px] mx-auto" data-testid="page-title-strip">
      <div className="flex items-center justify-between gap-3">
        <h1 className="font-display font-bold text-xl md:text-2xl leading-none text-slate-100">
          {TAB_TITLES[tab] || "Dashboard"}
        </h1>
        <div className="text-[11px] font-mono-data text-slate-500 uppercase tracking-widest">
          {TAB_SUBTITLES[tab] || ""}
        </div>
      </div>
    </div>
  );
}
